import type { TEmitterType } from '@semios/app-platform-values-helpers-and-types'
import { getEmitterTypeToEnum } from '@semios/app-platform-values-helpers-and-types'
import type { TValuesCurrentPoints } from 'App/Map/types'
import {
  CURRENT_PRESSURE_VALUE_TYPE_PREFIX,
  CURRENT_PRESSURE_VALUE_TYPE_SUFFIX,
} from './irrigationActivityConstants'

export type TPressureValueType = Extract<
  TValuesCurrentPoints,
  `${typeof CURRENT_PRESSURE_VALUE_TYPE_PREFIX}${string}${typeof CURRENT_PRESSURE_VALUE_TYPE_SUFFIX}`
>

export const insertEmitterTypeForPressure = (emitterType: TEmitterType): TPressureValueType =>
  `${CURRENT_PRESSURE_VALUE_TYPE_PREFIX}${getEmitterTypeToEnum(emitterType)}${CURRENT_PRESSURE_VALUE_TYPE_SUFFIX}`
